import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { range } from "lodash";
import * as moment from "moment";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { TranslateService } from "@root/shared/service/translate.service";
import { merge } from "rxjs";
import { delay } from "rxjs";
import { Router } from "@angular/router";
import { NzModalService } from "ng-zorro-antd/modal";
import { ViewVoucherComponent } from "@root/component/view-voucher/view-voucher.component";
import { padStart } from "@root/util/date";
import { DateService } from "@root/shared/service/date.service";

@Component({
  selector: "host-widget-checkin-block",
  templateUrl: "./checkin-block.component.html",
  styleUrls: ["./checkin-block.component.scss"],
})
export class WidgetCheckinBlockComponent implements OnInit {
  _orderDetail;
  @Input()
  get orderDetail() {
    return this._orderDetail;
  }
  set orderDetail(value) {
    this._orderDetail = value;

    this.form.patchValue(
      {
        check_in_time: value?.check_in_time,
        check_out_time: value?.check_out_time,
        visible_password_time: value?.guide_info?.visible_password_time,
        need_credential: value?.guide_info?.need_credential,
        password: value?.guide_info?.lock?.lock_password,
      },
      { emitEvent: false },
    );
  }

  @Input() isEditingLockPwd = false;

  @Output() onEdit = new EventEmitter();
  @Output() onCancelEdit = new EventEmitter();
  @Output() onCompleteEdit = new EventEmitter();

  form: UntypedFormGroup = this.fb.group({
    check_in_time: null,
    check_out_time: null,
    password: null,
    visible_password_time: null,
    need_credential: null,
  });

  optionsOfLockPwdVisibleTime = range(0, 24).map((i) => ({
    label: `${padStart(i)}:00`,
    value: `${padStart(i)}:00`,
  }));

  optionsOfCheckinHour = range(0, 26).map((i) => {
    const value = padStart(i);
    return {
      label: this.normalizeMinString(value),
      value: value,
      rawValue: i,
    };
  });

  optionsOfCheckoutHour = range(0, 24).map((i) => {
    const value = padStart(i);
    return {
      label: this.normalizeMinString(value),
      value: value,
      rawValue: i,
    };
  });
  listOfCredential = [];

  beforeUpload = (file) => {
    const size = file.size;
    const type = file.type;

    if (["image/jpeg", "image/jpg", "image/png"].indexOf(type) === -1) {
      // this.messageService.info('只允许上传jpg和png格式的图片');
      this.msg.info(this.t.t("component.upload.image_format_restrictions"));
      return false;
    }

    if (this.listOfCredential.length >= 10) {
      // this.messageService.info('上传图片数量已达上限');
      this.msg.info(this.t.t("component.upload.image_number_reached_limit"));
      return false;
    }

    if (size > 10 * 1024 * 1024) {
      // this.messageService.info('图片过大，请选择小于10M的图片上传！');
      this.msg.info(this.t.t("warning.upload_image_too_large"));
      return false;
    }

    return true;
  };

  constructor(
    private fb: UntypedFormBuilder,
    private orderSrv: OrderV2Service,
    private msg: NzMessageService,
    private modal: NzModalService,
    private router: Router,
    private t: TranslateService,
    private date: DateService,
  ) {}

  ngOnInit() {
    this.subscribeFormChange();
  }

  private subscribeFormChange() {
    this.form
      .get("need_credential")
      .valueChanges.pipe(delay(300))
      .subscribe((rst) => {
        console.log("need credential change: ", rst);
        this.onEditRegistration();
        // this.identityRegistrationChange(rst);
      });

    this.form
      .get("visible_password_time")
      .valueChanges.pipe(delay(300))
      .subscribe((rst) => {
        console.log("visible password time change: ", rst);
        this.onEditPasswordVisibleTime();
        // this.visiblePasswordTimeChange(rst);
      });
    merge(this.form.get("check_in_time").valueChanges, this.form.get("check_out_time").valueChanges)
      .pipe(delay(300))
      .subscribe((rst) => {
        this.onEditCheckinTime();
        // this.onConfirmEditCheckTime();
      });
  }

  onConfirmEditLockPW() {
    const form = this.form.value;
    if (!form.password) {
      return;
    }

    const params = {
      reservation_code: this.orderDetail.code,
      type: 2, // 手动填写
      password: form.password,
    };

    this.requestUpdateCheckinGuide(params);
    // this.orderSrv.setGuide(params).subscribe((rst: any) => {
    //   if (rst.error_code === 0) {
    //     this.onCompleteEdit.emit();
    //     this.msg.success(this.t.t("success.save"));
    //   }
    // });
  }

  onGenerateLockPW() {
    const params = {
      reservation_code: this.orderDetail.code,
      type: 1, // 随机生成
    };
    this.orderSrv.setGuide(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.onCompleteEdit.emit();
        this.msg.success(this.t.t("order.password_creating"));
      }
    });
  }

  onDeleteLockPW() {
    const params = {
      reservation_code: this.orderDetail.code,
      type: 3, // 删除密码
    };
    this.orderSrv.setGuide(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.onCompleteEdit.emit();
        this.msg.success(this.t.t("success.password_deleted"));
      }
    });
  }

  onEditCheckinTime() {
    const value = this.form.value;
    if (!value.check_in_time && !value.check_out_time) {
      return;
    }
    const params = {
      reservation_code: this.orderDetail.code,
      check_in_time: value.check_in_time,
      check_out_time: value.check_out_time,
    };
    this.requestUpdateCheckinTime(params);
  }

  onEditRegistration() {
    const form = this.form.value;
    const params = {
      reservation_code: this.orderDetail.code,
      type: 5, // 设置是否需要登记
      need_credential: form.need_credential,
    };
    this.requestUpdateCheckinGuide(params);
  }

  onEditPasswordVisibleTime() {
    const form = this.form.value;
    const params = {
      reservation_code: this.orderDetail.code,
      type: 4, // 设置密码可见时间
      visible_password_time: form.visible_password_time,
    };
    this.requestUpdateCheckinGuide(params);
  }

  onUploadCredentials(result) {
    const file = result.file;
    if (file.status === "done") {
      const urls = file?.response?.data?.file;
      this.requestAddCredentials(JSON.stringify(urls));
    }
  }

  onViewCredentials() {
    this.modal.create({
      nzTitle: this.t.t("word.credentials"),
      nzWidth: 715,
      nzFooter: null,
      nzContent: ViewVoucherComponent,
      nzComponentParams: {
        type: "credentials",
        orderCode: this.orderDetail.reservation_order.code,
        code: this.orderDetail.code,
        auditStatus: this.orderDetail?.guide_info?.human_auditing_status,
      },
      nzOnOk: () => {
        this.onCompleteEdit.emit();
      },
    });
  }

  toCheckinGuidePage() {
    this.modal.closeAll();
    this.router.navigate(["/app/settings/check-in-guide"]);
  }

  private requestUpdateCheckinGuide(params) {
    this.orderSrv.setGuide(params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("word.success"));
        this.onCompleteEdit.emit();
      }
    });
  }

  private requestUpdateCheckinTime(params) {
    this.orderSrv.setCheckInAndOutTime(params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("word.success"));
        this.onCompleteEdit.emit();
      }
    });
  }

  private requestAddCredentials(image: string) {
    const params = {
      reservation_code: this.orderDetail.code,
      image,
    };
    this.orderSrv.addGuideImage(params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.onCompleteEdit.emit();
      }
    });
  }

  private normalizeMinString(min: string) {
    if (!this.date.use12hr) {
      return min;
    }
    const prefix = "2022-11-11T";
    if (+min >= 24) {
      return this.t.t("word.next_day") + " " + this.date.format(`${prefix}${padStart(+min % 24)}:00`, [null, "h"]);
    } else {
      return this.date.format(`${prefix}${min}:00`, [null, "h"]);
    }
  }
}
